import { Form, Link } from '@remix-run/react';
import { getFormProps, getInputProps } from '@conform-to/react';
import { FieldGroup } from '~/application/components/FieldGroup/FieldGroup';
import { Input } from '~/application/components/Input/Input';
import { Button } from '~/application/components/Button/Button';
import { useSignupForm } from './useSignupForm';
import styles from './SignupForm.module.css';

export const SignupForm = () => {
  const { form, data } = useSignupForm();

  return (
    <Form method="post" {...getFormProps(form)}>
      <div className={styles.fields}>
        <FieldGroup
          label="名前"
          error={data.name.errors && data.name.errors[0]}>

          <Input {...getInputProps(data.name, { type: 'text' })} />
        </FieldGroup>
        <FieldGroup
          label="メールアドレス"
          error={data.email.errors && data.email.errors[0]}>

          <Input {...getInputProps(data.email, { type: 'text' })} />
        </FieldGroup>
        <FieldGroup
          label="パスワード"
          error={data.password.errors && data.password.errors[0]}>

          <Input {...getInputProps(data.password, { type: 'password' })} />
        </FieldGroup>
        <FieldGroup
          error={data.termAndPrivacy.errors && data.termAndPrivacy.errors[0]}>

          <label>
            <input
              className="mr-2"
              {...getInputProps(data.termAndPrivacy, { type: 'checkbox' })} />

            <span>
              <Link to="/term" className="underline">
                利用規約
              </Link>
              と
              <Link to="/privacy" className="underline">
                プライバシーポリシー
              </Link>
              に同意する
            </span>
          </label>
        </FieldGroup>
      </div>

      <Button color="primary" block>
        作成
      </Button>
    </Form>);

};